import { ANCILLARY_FILTER_DATA_REQUEST, ANCILLARY_FILTER_DATA_SUCCESS, ANCILLARY_FILTER_DATA_FAILURE, ANCILLARY_CAT_DETAILS_DATA_REQUEST, ANCILLARY_CAT_DETAILS_DATA_SUCCESS, ANCILLARY_CAT_DETAILS_DATA_FAILURE, ANCILLARY_NET_CAT_DETAILS_DATA_REQUEST, ANCILLARY_NET_CAT_DETAILS_DATA_SUCCESS, ANCILLARY_NET_CAT_DETAILS_DATA_FAILURE, ANCILLARY_EXPORT_LINK_REQUEST, ANCILLARY_EXPORT_LINK_SUCCESS, ANCILLARY_EXPORT_LINK_FAILURE, ANCILLARY_CATEGORY_VIEW_DATA_REQUEST, ANCILLARY_CATEGORY_VIEW_DATA_SUCCESS, ANCILLARY_CATEGORY_VIEW_DATA_FAILURE } from '../../actions/actionTypes';

interface LabsReducerState {
    filterDetails: any;
    filterDetailsIsLoading: boolean;
    filterDetailsError: string | null;
    labCatDetails: any;
    labCatDetailsIsLoading: boolean;
    labCatDetailsError: string | null;
    labNetCatDetails: any;
    labNetCatDetailsIsLoading: boolean;
    labNetCatDetailsError: string | null;
    labExportDetails: any;
    labExportDetailsIsLoading: boolean;
    labExportDetailsError: string | null;
    labCatViewData: any;
    labCatViewDataIsLoading: boolean;
    labCatViewDataError: string | null;
}

const initialState: LabsReducerState = {
    filterDetails: {},
    filterDetailsIsLoading: false,
    filterDetailsError: null,
    labCatDetails: {},
    labCatDetailsIsLoading: true,
    labCatDetailsError: null,
    labNetCatDetails: {},
    labNetCatDetailsIsLoading: false,
    labNetCatDetailsError: null,
    labExportDetails: {},
    labExportDetailsIsLoading: false,
    labExportDetailsError: null,
    labCatViewData: {},
    labCatViewDataIsLoading: false,
    labCatViewDataError: null,
};

 const LabsReducer = (
    state = initialState,
    action: { type: string; payload?: any }
  ): LabsReducerState => {
    switch (action.type) {
      case ANCILLARY_FILTER_DATA_REQUEST:
        return {
          ...state,
          filterDetailsIsLoading: true,
        };
  
      case ANCILLARY_FILTER_DATA_SUCCESS:
        return {
          ...state,
          filterDetails: action.payload,
          filterDetailsIsLoading: false,
        };

      case ANCILLARY_FILTER_DATA_FAILURE:
        return {
          ...state,
          filterDetailsError: action.payload,
          filterDetailsIsLoading: false,
        };

        case ANCILLARY_CAT_DETAILS_DATA_REQUEST:
          return {
            ...state,
            labCatDetailsIsLoading: true,
          };
    
        case ANCILLARY_CAT_DETAILS_DATA_SUCCESS:
          return {
            ...state,
            labCatDetails: action.payload,
            labCatDetailsIsLoading: false,
          };
  
        case ANCILLARY_CAT_DETAILS_DATA_FAILURE:
          return {
            ...state,
            labCatDetailsError: action.payload,
            labCatDetailsIsLoading: false,
          };

          case ANCILLARY_NET_CAT_DETAILS_DATA_REQUEST:
          return {
            ...state,
            labNetCatDetailsIsLoading: true,
          };
    
        case ANCILLARY_NET_CAT_DETAILS_DATA_SUCCESS:
          return {
            ...state,
            labNetCatDetails: action.payload,
            labNetCatDetailsIsLoading: false,
          };
  
        case ANCILLARY_NET_CAT_DETAILS_DATA_FAILURE:
          return {
            ...state,
            labNetCatDetailsError: action.payload,
            labNetCatDetailsIsLoading: false,
          };


          case ANCILLARY_EXPORT_LINK_REQUEST:
            return {
              ...state,
              labExportDetails: {},
              labExportDetailsIsLoading: true,
            };
      
          case ANCILLARY_EXPORT_LINK_SUCCESS:
            return {
              ...state,
              labExportDetails: action.payload,
              labExportDetailsIsLoading: false,
            };
    
          case ANCILLARY_EXPORT_LINK_FAILURE:
            return {
              ...state,
              labExportDetails: {},
              labExportDetailsError: action.payload,
              labExportDetailsIsLoading: false,
            }; 
            
            
            case ANCILLARY_CATEGORY_VIEW_DATA_REQUEST:
              return {
                ...state,
                labCatViewDataIsLoading: true,
              };
        
            case ANCILLARY_CATEGORY_VIEW_DATA_SUCCESS:
              return {
                ...state,
                labCatViewData: action.payload,
                labCatViewDataIsLoading: false,
              };
      
            case ANCILLARY_CATEGORY_VIEW_DATA_FAILURE:
              return {
                ...state,
                labCatDetailsError: action.payload,
                labCatViewDataIsLoading: false,
              };   
        

      default:
        return state;
    }
  };

export default LabsReducer;